import * as React from 'react';
import { ButtonMobile, ButtonDesktop } from '../pages/Authentication/styles';
import Button from '../components/Button';

interface Props {
  widthMobile?: string;
  widthDesktop?: string;
  buttonText?: string;
  buttonType?: string;
  onClick?: () => void;
  [key: string]: any;
}
const MediaButtons = (props: Props) => {
  return (
    <>
      <ButtonMobile>
        <Button
          width={props.widthMobile}
          buttonText={props.buttonText}
          buttonType={props.buttonType}
          onClick={props.onClick}
          {...props}
        />
      </ButtonMobile>
      <ButtonDesktop>
        <Button
          width={props.widthDesktop}
          buttonText={props.buttonText}
          buttonType={props.buttonType}
          onClick={props.onClick}
          {...props}
        />
      </ButtonDesktop>
    </>
  );
};

export default MediaButtons;
